import { render, staticRenderFns } from "./AddSize.vue?vue&type=template&id=5e0bf43e&"
import script from "./AddSize.vue?vue&type=script&lang=js&"
export * from "./AddSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports